/* eslint-disable */
import React, { lazy, Suspense } from 'react';
import ToastMarker from 'react-geek-toast';
import { useApiGet } from 'react-reqq-lite';
import { useAuth } from 'modules/auth/hooks';
import Logout from 'modules/auth/containers/Logout';
import { Link, Route, Switch } from 'react-router-dom';
import { AUTHENTICATION } from 'modules/auth/constants';
import VerifyEmail from 'modules/auth/containers/VerifyEmail';
import {
  AlertMarker,
  ModalMarker,
  DrawerMarker,
  LightboxMarker,
} from 'partial/components/Modal';
import ErrorBoundary from 'partial/containers/ErrorBoundary';
import Public from './Public';

const Private = lazy(() => import('./Private'));

export const PURGE_IGNORE = () => <input type="tel" />;

const PrivateRoutes = React.memo(() => {
  const auth = useApiGet(AUTHENTICATION, {});
  return <Private />
  // if (auth.userType === 'ADMINISTRATOR') return <Private />;
  return (
    <Switch>
      <Route path="/logout" component={Logout} />
      <Route>
        <div>
          Unknown user type.{' '}
          <Link className="text-primary-500 hover:underline" to="/logout">
            Logout
          </Link>
        </div>
      </Route>
    </Switch>
  );
});

function App() {
  const [isAppReady, isAuthenticated] = useAuth();
  if (!isAppReady) return null;
  return (
    <ErrorBoundary>
      <ToastMarker />
      <AlertMarker />
      <LightboxMarker />
      <ModalMarker />
      <DrawerMarker />
      <Suspense fallback={<div />}>
        <Switch>
          <Route exact path="/email-verification" component={VerifyEmail} />
          <Route>{isAuthenticated ? <PrivateRoutes /> : <Public />}</Route>
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
